import { SourceType } from './source-type.enum';
var SourceTypeUtils = /** @class */ (function () {
    function SourceTypeUtils() {
    }
    SourceTypeUtils.sourceTypeToString = function (sourceType, sourceId) {
        return sourceType === SourceType.HELP_CENTER ? '0' : "".concat(sourceType).concat(this.delimiter).concat(sourceId);
    };
    SourceTypeUtils.stringToSourceType = function (sourceTypeString) {
        return sourceTypeString.indexOf(this.delimiter) > 0 ? sourceTypeString.split(this.delimiter)[0] === '1' ? SourceType.WIDGET : SourceType.OLD_WIDGET : SourceType.HELP_CENTER;
    };
    SourceTypeUtils.delimiter = '_';
    return SourceTypeUtils;
}());
export { SourceTypeUtils };
//# sourceMappingURL=source-type-utils.js.map